import { render, staticRenderFns } from "./DocumentsPDFRender.vue?vue&type=template&id=2f33aa12&lang=pug"
import script from "./DocumentsPDFRender.vue?vue&type=script&lang=js"
export * from "./DocumentsPDFRender.vue?vue&type=script&lang=js"
import style0 from "./DocumentsPDFRender.vue?vue&type=style&index=0&id=2f33aa12&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports